// eslint-disable-next-line no-restricted-imports
import orgFeatures from 'common/data/org-features';
// eslint-disable-next-line no-restricted-imports
import { TeamModel } from 'types';

export const isPremiumTeam = (team: TeamModel): boolean => {
  return orgFeatures.hasProduct(team.products || []);
};

export const freeBoardsRemaining = (team: TeamModel): number | undefined => {
  if (isPremiumTeam(team) || !team.limits) {
    return undefined;
  }

  const limit = team.limits.orgs.freeBoardsPerOrg;
  if (limit.count === undefined) {
    return undefined;
  }

  const delta = limit.disableAt - limit.count;

  return delta < 0 ? 0 : delta;
};

export const freeBoardsOver = (team: TeamModel): number => {
  if (isPremiumTeam(team) || !team.limits) {
    return 0;
  }

  const limit = team.limits.orgs.freeBoardsPerOrg;
  if (limit.count === undefined) {
    return 0;
  }

  const delta = limit.disableAt - limit.count;

  return delta < 0 ? Math.abs(delta) : 0;
};

export const isCloseToFreeBoardLimit = (team: TeamModel): boolean => {
  const remaining = freeBoardsRemaining(team);

  return remaining !== undefined && remaining <= 3;
};

export const isAtOrOverFreeBoardLimit = (team: TeamModel): boolean => {
  const remaining = freeBoardsRemaining(team);

  return remaining === 0;
};

export const isFreeBoardLimitOverridden = (team: TeamModel): boolean => {
  if (isPremiumTeam(team) || !team.limits) {
    return false;
  }

  const limit = team.limits.orgs.freeBoardsPerOrg;

  return limit.disableAt !== 10;
};

export const openBoardCount = (team: TeamModel): number | undefined => {
  if (!team.limits) {
    return undefined;
  }

  return team.limits.orgs.freeBoardsPerOrg.count;
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/model-helpers/team.ts